import React from "react";

import "./About.css";
import aboutImg from "../../../img/architektura/Rysunek_odreczny.jpg";

const about = () => {
  return (
    <section id="about-us-architecture" className="py-3">
      <div className="container p-5">
        <div className="row">
          <div className="col-lg-7">
            <h1 className="mb-4">Akcent-Bud </h1>
            <h3 className="pb-3 orange-color">
              20 lat doświadczeń
            </h3>
            <div className="text-muted">
              Firma „AKCENT-BUD” zajmuje się projektowaniem architektonicznym, w
              tym aranżacją wnętrza. Dekorujemy pojedyncze pomieszczenia i
              opracowujemy indywidualny styl całego obiektu. Aranżujemy elewacje
              istniejących budynków jak i tworzymy całe nowe bryły obiektów.
              Projektujemy też elementy zewnętrzne: od kostki brukowej, przez
              małą architekturę po całe ogrody. Często wykonujemy kilka z tych
              zakresów, co pozwala na stworzenie kompleksowego planu
              przestrzeni.
            </div>
            <div className="text-muted">
              Po etapie projektowania przychodzi czas na realizację. Firma
              „AKCENT-BUD” wyspecjalizowała się w:
              <ul>
                <li>szpachlowaniu i malowaniu ścian oraz sufitów</li>{" "}
                <li>
                  prostych i skomplikowanych zabudowach gipsowo-kartonowych
                </li>{" "}
                <li>panelach podłogowych, płytkach ceramicznych i gresowych</li>{" "}
                <li>elementach sztukaterii i ozdobnych panelach ściennych</li>{" "}
                <li>zabudowach systemowych i modułowych</li>
              </ul>
            </div>
            <div className="text-muted">
              Współpracują z innymi firmami wykonujemy:{" "}
              <ul>
                <li>instalacje elektryczne i teletechniczne</li>{" "}
                <li>instalacje wodno-kanalizacyjne i centralnego ogrzewania</li>{" "}
                <li>tynki i posadzki maszynowe</li> <li>ocieplenia elewacji</li>
              </ul>
              Świadcząc w ten sposób kompleksowe usługi budowlane.
            </div>
            <br />
            <div className="text-muted">
              Moja historia:
              <ul>
                <li>
                  1993-1994 Asystent Projektanta w Agencji Reklamowej „BLIK” w
                  Tarnowie
                </li>{" "}
                <li>
                  1994-1997 Projektant wnętrz w firmie „ART-STUDIO” w Tarnowie
                  0d
                </li>{" "}
                <li>
                  1996- do dziś prowadzę w Tarnowie własną firmę „AKCENT-BUD”,
                  co już uważam za duży sukces.
                </li>{" "}
              </ul>
            </div>
          </div>
          <div className="col-lg-5 mt-5 d-flex align-items-center">
            <img src={aboutImg} alt="" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default about;



// WEBPACK FOOTER //
// ./src/components/Architecture/About/About.js